import React from "react";
import NoData from "../../../images/noData.svg";
const NoDataFound = () => {
  return (
    <div className="text-center">
      <img src={NoData} alt="No Data" width={300} />
    </div>
  );
};

export default NoDataFound;
